<template lang="pug">
.item(
	v-if="listo"
	:style="{cursor: 'pointer', 'background-image': 'url(' + portada + ')'}"
	@click="$emit('selecciona', datos.GaleriaID)"
)
	.tituloGaleria
		| {{datos.Nombre}}
		br
		span(style="color:#666666;") {{datos.FechaUnix | moment('DD-MMM-Y')}}
</template>
<script>
import axios from 'axios'
export default {
	props: ['galeria', 'GaleriaID'],
	data () {
		return {
			datos: null,
			listo: false
		}
	},
	created () {
		if (this.galeria) {
			this.datos = this.galeria
			this.listo = true
		} else if (this.GaleriaID) {
			axios.post('galerias/php/api/get-galeria-portada.php', { GaleriaID: this.GaleriaID })
				.then(res => {
					this.datos = res.data
					this.listo = true
				})
				.catch(e => {
					this.datos = {
						Nombre: 'Galería no encontrada',
						GaleriaID: this.GaleriaID,
						FechaUnix: Math.floor(new Date().getTime() / 1000)
					}
					this.listo = true
				})
		}
	},
	computed: {
		portada () {
			if (!this.datos) {
				return '/src/modulos/galerias/static/noimage.png'
			}
			return (this.datos.PortadaID) ? '/src/modulos/galerias/php/api/thumb.php?ItemID=' + this.datos.PortadaID : '/src/modulos/galerias/static/noimage.png'
		}
	}
}
</script>

<style scoped>
.item {
	position: relative;
	display: inline-block;
	width: 200px;
	height: 200px;
	background-position: center;
	background-size: cover;
	background-repeat: no-repeat;
	margin: 5px;
	border: 1px solid #e0e0e0;
	border-radius: 2px;
}
.tituloGaleria {
	position: absolute;
	display: block;
	bottom: 0;
	left: 0;
	right: 0;
	overflow: hidden;
	text-align: center;
	padding: 3px;
	background-color: white;
}
</style>



// WEBPACK FOOTER //
// src/modulos/galerias/vue/componentes/listado-galerias/mini-galeria.vue